import NewNote from './NewNote';

export default NewNote;
